module.exports = __webpack_public_path__ + "static/img/sz.acd60b76.png";